export default function AboutHero() {
  return (
    <section className="relative pt-36 pb-24 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/bc41bbabb8078d73b301d9afc11bbced.jpg"
          alt="About AWWAL"
          className="w-full h-full object-cover object-top opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#080808]/90 via-[#080808]/60 to-[#080808]" />
      </div>
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="inline-flex items-center gap-2 px-4 py-2 border border-[#00ff88]/30 rounded-sm bg-[#00ff88]/5 mb-8">
          <span className="w-1.5 h-1.5 rounded-full bg-[#00ff88] animate-pulse" />
          <span className="text-[#00ff88] text-xs tracking-[0.3em] uppercase font-semibold font-inter">Our Story</span>
        </div>
        <h1 className="text-5xl lg:text-7xl font-black text-white tracking-tight leading-none mb-6 max-w-3xl font-syne">
          Crafted in Malaysia.<br /><span className="text-[#00ff88]">Built for the World.</span>
        </h1>
        <p className="text-white/45 text-lg max-w-2xl leading-relaxed font-inter">
          AWWAL Marine &amp; Engineering SDN. BHD. is a digital powerhouse at the intersection of gaming, technology, and community. Founded with a relentless drive to reshape how people play, compete, and connect online.
        </p>
      </div>
    </section>
  );
}
